import { render, staticRenderFns } from "./ClientsView.vue?vue&type=template&id=549a9a63&scoped=true"
import script from "./ClientsView.vue?vue&type=script&lang=js"
export * from "./ClientsView.vue?vue&type=script&lang=js"
import style0 from "./ClientsView.vue?vue&type=style&index=0&id=549a9a63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549a9a63",
  null
  
)

export default component.exports